import { render } from "./TableDocuments.vue?vue&type=template&id=4167d025&scoped=true"
import script from "./TableDocuments.vue?vue&type=script&lang=js"
export * from "./TableDocuments.vue?vue&type=script&lang=js"

import "./TableDocuments.vue?vue&type=style&index=0&id=4167d025&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4167d025"]])

export default __exports__